var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoryline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c96cb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.71,193.35a23.57,23.57,0,0,1,1.69-2.52c.66-.72,1.45-1.33,2.45-2.22,5.17,2.94,9.77,6.81,15.63,8.52,8.81,2.58,17.39,2.85,25.74-1.31,5.37-2.67,8.25-6.91,8-13.2-.27-5.79-3.87-8.42-8.64-10.33-9.43-3.78-19.66-4.76-29.11-8.45-5.64-2.19-10.69-4.85-11.58-11.69-1.08-8.29.64-15.64,7.58-20.93,11.24-8.56,33.32-7.62,44,1.75,1.74,1.52,4,3,1.58,5.68s-3.84.74-5.77-.86c-8.1-6.69-25.35-7.81-34.15-2.42-4.29,2.62-7.14,9-6,14.39s5.16,7.65,10,9.09c9.19,2.75,18.49,5.07,27.67,7.89,14.72,4.51,15,19.75,7.54,29.29a22.53,22.53,0,0,1-13.05,7.77C131.42,207.35,116.64,205,103.71,193.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.89,196.37c2.12,5.79,1.68,6.64-3.73,7.66-4.45.85-9,1.67-13.25-.37-5.36-2.61-8.06-7-8-13.23q.17-44.7,0-89.4c0-2.9,0-5.14,4.05-5.15s4.15,2.1,4.14,5.08q-.07,41.7,0,83.4c0,11.95,3.13,14.46,15,12A10.7,10.7,0,0,1,204.89,196.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,0A157,157,0,1,0,314,157,157,157,0,0,0,157,0Zm0,309.08A152.08,152.08,0,1,1,309.08,157h0A151.37,151.37,0,0,1,158.42,309.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryline);
export default __webpack_public_path__ + "static/media/storyline.6ac5deca.svg";
export { ForwardRef as ReactComponent };